import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Body } from "syf-component-library/ui/typography";
import i18n from "../../../strings/i18n";
import { LoanPaidOffMessageSubTitle, LoanPaidOffMessageTitle, LoanPaidOffMessageWrap, } from "./LoanPaidOffMessage.styles";
var LoanPaidOffMessage = function () {
    return (_jsxs(LoanPaidOffMessageWrap, { children: [_jsx(LoanPaidOffMessageTitle, { children: i18n({ loanPaidOff: "title" }) }), _jsxs(LoanPaidOffMessageSubTitle, { children: [_jsx(Body, { children: i18n({ loanPaidOff: "heading" }) }), _jsx(Body, { children: i18n({ loanPaidOff: "subHeading" }) })] })] }));
};
export default LoanPaidOffMessage;
//# sourceMappingURL=LoanPaidOffMessage.js.map